import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Container} from "react-bootstrap";

export const FinalCta: FC = () => {
	const {t} = useTranslation();

	return (
		<section className="final-cta" id="start">
			<Container>
				<div className="final-cta__inner">
					<h2 className="final-cta__title">{t("finalCta.title")}</h2>
					<p className="final-cta__subtitle">{t("finalCta.subtitle")}</p>
					<button type="button" className="btn btn-light btn-lg final-cta__button" disabled>
						{t("cta.comingSoon")}
					</button>
				</div>
			</Container>
		</section>
	);
};
